import React from "react";
import NotesTable from "./NotesTable";

const Notes = (props) => {
    const { email, notes } = props.user;
    
    return (
        <>
            <div className="flex mx-auto self-center">
                <div className="flex flex-col flex-1">
                    <h1 className="text-2xl font-title font-light">Notes</h1>
                    <NotesTable 
                        notesData={notes}
                        userId={email}
                    />
                </div>
            </div>
        </>
    );
}

export default Notes;
